// extracted by mini-css-extract-plugin
export default {"popover":"BasePopover_popover__+lkbf"};